//@flow
import { useViewport } from 'components/templates/viewportProvider';
import React, { useState } from 'react';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { OurDifferenceMobMultiCarousel } from 'components/molecules/OurDifferenceMobMultiCarousel';
//eslint-disable-next-line
import styles from "./style.scss";

type Props = {
  our_difference_heading: string,
  infoLinks: Array<infoLinksProps>,
  cmsDetailsData: Object<cmsDetailsDataProps>,
};

type dataProps = {
  id: number,
  tag_word: string,
  image: string,
  mobile_image: string,
  page_title: string,
  parent_page_title: string,
  short_content: Object,
  long_content: Object,
  short_mobile_content: Object,
  cms_page_id: number,
  path: string,
  web: string,
  mobile: string,
};

type infoLinksProps = {
  data: Array<dataProps>,
  title: string,
  link: string,
  id: number,
};

type cmsDetailsDataProps = {
  id: number,
  page_title: string,
  cms_detail_page_contents: Object,
  media_path: string,
  thumbnail: string,
  mobile: string,
  web: string,
};

const OurDifferenceMobileView = (props: Props) => {
  const { height } = useViewport();
  const {
    our_difference_heading,
    infoLinks,
    cmsDetailsData,
    breadcrumbList,
  } = props;
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [overlay_page_data, set_overlay_page_data] = useState({});
  const media_path =
    infoLinks.length > 0 && infoLinks[0].data.media_path_mobile;
  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'ourDifference'}
        mediaPath={media_path}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className="ourDifference-mobile-body" style={{ height }}>
      <div className={'upper-content'}>
        <h2 className="TE-heading">{our_difference_heading}</h2>
      </div>

      <OurDifferenceMobMultiCarousel
        infoLinks={infoLinks}
        cssFor={'horizontal-carousel-container'}
        media_path={media_path}
        cmsDetailsData={cmsDetailsData}
        renderOverlayPage={e => setshowDescriptionLayout(e)}
        overlay_data={e => set_overlay_page_data(e)}
      />
      {showOverlay}
    </div>
  );
};
export default OurDifferenceMobileView;
